/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Init Slick Slider
 * ########################################
 */

jQuery(document).ready(function($) {

    var filer = $('.filter-container').filterizr({
        delay: 25,
        setupControls: false, // this to disable the default control
        layout: 'packed',
    });

    // first filter nav
    $('.filter-btn').click(function() {
    $('.filter-btn').removeClass('filtr-active');
        $(this).addClass('filtr-active');
        var filter = $(this).data('filter');
        filer.filterizr('filter', filter);
    });

});

